'use server'

import { apiRequest, ApiResponse } from '../request'

export type SalesTaskType = 'TASK_CALL' | 'TASK_FOLLOW_UP' | 'TASK_MEETING' | 'TASK_SEND_QUOTE' | 'TASK_OTHER'

/** Tarefa de vendas: evento TASK_* na agenda pessoal do responsável. */
export interface SalesTask {
    id: number
    type: SalesTaskType
    title: string
    description?: string | null
    notes?: string | null
    status: 'PENDING' | 'CONFIRMED' | 'OVERDUE' | 'COMPLETED' | 'CANCELED'
    startDate: string
    endDate: string
    allDay: boolean
    completedAt?: string | null
    leadId?: number | null
    dealId?: number | null
    agenda: { id: number; userId: number | null; user?: { id: number; name: string } | null }
    lead?: { id: number; name: string } | null
    deal?: { id: number; title: string } | null
}

export async function getSalesTasks(filters: { leadId?: number; dealId?: number; mine?: boolean; open?: boolean }): Promise<ApiResponse<SalesTask[]>> {
    return apiRequest<SalesTask[]>('sales/tasks', { params: filters as any })
}

export async function createSalesTask(data: {
    type: SalesTaskType
    title: string
    description?: string
    startDate: string
    durationMinutes?: number
    allDay?: boolean
    leadId?: number
    dealId?: number
    assignedUserId?: number
}): Promise<ApiResponse<SalesTask>> {
    return apiRequest<SalesTask>('sales/tasks', { data }, 'post')
}

export async function completeSalesTask(id: number, result?: string): Promise<ApiResponse<SalesTask>> {
    return apiRequest<SalesTask>(`sales/tasks/${id}/complete`, { data: { result } }, 'patch')
}

export async function cancelSalesTask(id: number, result?: string): Promise<ApiResponse<SalesTask>> {
    return apiRequest<SalesTask>(`sales/tasks/${id}/cancel`, { data: { result } }, 'patch')
}

export async function rescheduleSalesTask(id: number, data: { startDate: string; allDay?: boolean }): Promise<ApiResponse<SalesTask>> {
    return apiRequest<SalesTask>(`sales/tasks/${id}/reschedule`, { data }, 'patch')
}
